import { FormControl, FormGroup } from '@angular/forms';
import {AngularFirestore} from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CouponService {

  constructor(private firestore: AngularFirestore ) {}

  form = new FormGroup({
    mail: new FormControl(''),
    code: new FormControl('')
  });


  getCoupon() {
    return this.firestore.collection('coupon').snapshotChanges();
  }




}
